import { gqlClient } from '@/api/graphql-client';
import { graphql } from '@/gql';
import { CreateClientPortalPreviewMutation as _CreateClientPortalPreviewMutation } from '@/gql/graphql';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

const CreateClientPortalPreviewMutation = graphql(`
  mutation CreateClientPortalPreview($input: CreateClientPortalPreviewInput!) {
    createClientPortalPreview(input: $input) {
      url
      expiresAt
    }
  }
`);

const useCreateClientPortalPreview = (
  options?: UseMutationOptions<
    _CreateClientPortalPreviewMutation,
    unknown,
    string
  >
) => {
  return useMutation({
    mutationFn: (projectId: string) =>
      gqlClient.request(CreateClientPortalPreviewMutation, {
        input: { projectId },
      }),
    ...options,
  });
};

export default useCreateClientPortalPreview;
